import raf from 'raf';
import MdObserveEvent from './MdObserveEvent';
import { defineComponent } from 'vue';
export default (el = window, observerFn) => {
  const observer = MdObserveEvent(
    el,
    'resize',
    () => {
      raf(observerFn);
    },
    { passive: true }
  );

  return {
    destroy: observer.destroy,
  };
};
